import script from "./LaputaBlogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaBlogDetail.vue?vue&type=script&setup=true&lang=js"

import "./LaputaBlogDetail.vue?vue&type=style&index=0&id=0772ca44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0772ca44"]])

export default __exports__